(function (upp) {
    'use strict';

    upp.controller('upp.TokenCtrl', [
        '$rootScope',
        '$routeParams',
        'location',
        'storage',
        'authManager',
        function ($rootScope, $routeParams, location, storage, authManager) {
            var token = $routeParams.token;

            if (token) {
                token = atob(token);

                storage.set('upplicationToken', token);

                var auth = {
                    type: 'Token',
                    token: token
                };


                authManager.login(auth).then(function () {
                    if (storage.get('redirectToCart') === 'true') {
                        storage.remove('redirectToCart');
                        location.path('/cart/order');
                    } else if (storage.get('redirectToBookings') === 'true') {
                        storage.remove('redirectToBookings');
                        var selectedCalendar = storage.get('bookingCalendar');
                        location.path('/booking/' + selectedCalendar);
                    } else {
                        location.path('/');
                    }

                    $rootScope.$broadcast('registerSuccess:open');
                });
            } else {
                location.path('/');
            }
        }
    ]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/common/controllers/token-controller.js